import { useState, useCallback } from 'react';
import { getConsentStatus, ConsentStatusResult } from '../services/api';

export function useConsentStatus(clientId: string | undefined) {
  const [status, setStatus] = useState<ConsentStatusResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStatus = useCallback(async () => {
    if (!clientId) return;

    setLoading(true);
    setError(null);

    try {
      const result = await getConsentStatus(clientId);
      setStatus(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch consent status');
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  const refetch = useCallback(() => {
    fetchStatus();
  }, [fetchStatus]);

  return {
    status,
    loading,
    error,
    fetchStatus,
    refetch,
  };
}
